<template>
    <div class="linea-pedido">
        <div class="linea-pedido-wrapper">
            <div class="linea-pedido-img-wrapper">
                <img :src="imgUrl" alt="Imagen variedad">
            </div>
            <div class="linea-pedido-variety-info">
                <div>
                    <img src="/img/iconos/icon_ecologico.svg" alt="Ecológico" class="pedido-id-icon" v-if="isEco">
                    <img src="/img/iconos/icon_bp_seleccion_custom.svg" alt="Babyplant selección" class="pedido-id-icon" v-if="isBpSeleccion">
                    <img src="/img/iconos/icon_injertada.svg" alt="Injerto" class="pedido-id-icon" v-if="isInjerto">
                </div>
                <pedido-linea-param-perfil title="Variedad">
                    <div class="d-flex" style="flex-wrap: wrap">
                        <div class="d-inline-block">
                            {{ especieName }}
                        </div>
                        <div class="d-inline-block">
                            {{ variedadName }}
                        </div>
                    </div>
                </pedido-linea-param-perfil>
                <pedido-linea-param-perfil v-if="isMedida && isInjerto" title="Porta">
                    <div class="d-flex" style="flex-wrap: wrap">
                        <div class="d-inline-block">
                            {{ especiePieName }}
                        </div>
                        <div class="d-inline-block">
                            {{ variedadPieName }}
                        </div>
                    </div>
                </pedido-linea-param-perfil>
            </div>
            <div class="linea-pedido-pricing">
                <div class="linea-pedido-formato">
                    <pedido-linea-param-perfil title="Nº Bandejas">
                        {{ nBandejas }}
                    </pedido-linea-param-perfil>
                    <pedido-linea-param-perfil title="Formatos bandeja">
                        {{ formatoBandejaCompleto }}
                    </pedido-linea-param-perfil>
                </div>
                <div class="linea-pedido-importe">
                    <pedido-linea-param-perfil title="Importe">
                        {{ importe | formatMoney }}
                    </pedido-linea-param-perfil>
                    <pedido-linea-param-perfil title="Descuento">
                        {{ descuento | formatMoney }}
                    </pedido-linea-param-perfil>
                </div>
                <pedido-linea-param-perfil title="Total">
                    {{ total | formatMoney }}
                </pedido-linea-param-perfil>
            </div>
            <div class="linea-pedido-actions">
                <div class="linea-pedido-btn-wrapper" v-if="canValorar">
                    <valorar-variedad-btn :pedido-line-id="this.line.id" :custom-type="isMedida" @voted="votedEvent"></valorar-variedad-btn>
                </div>
                <div class="linea-pedido-btn-wrapper">
                    <button class="linea-pedido-btn comprar-linea-pedido-btn" @click="volverComprar">
                        Volver a comprar
                        <div class="linea-pedido-id-icon-positioner">
                            <cart-icon></cart-icon>
                        </div>
                    </button>
                </div>
            </div>
        </div>
        <volver-comprar-modal v-if="volverComprarPedidoLine" :line="line" :line-type="lineType"
                              :show-modal.sync="volverComprarPedidoLine"></volver-comprar-modal>
    </div>
</template>

<script>
import PedidoLineaParamPerfil from "./PedidoLineaParamPerfil";
import ValorarVariedadBtn from "./ValorarVariedadBtn";
import CartIcon from "./CartIcon";
import VolverComprarModal from "./VolverComprarModal";
export default {
    name: "PedidoLineaPerfil",
    components: {VolverComprarModal, CartIcon, ValorarVariedadBtn, PedidoLineaParamPerfil},
    props: {
        line: {
            type: Object,
            required: true
        },
        lineType: {
            type: String,
            default: 'Disponible',
            validator(val) {
                return ['Disponible', 'Medida'].indexOf(val) !== -1;
            }
        }
    },
    data() {
        return {
            volverComprarPedidoLine: false,
            volverComprarMedidaLoading: false,
        }
    },
    computed: {
        isDisponible() {
            return this.lineType === 'Disponible';
        },
        isMedida() {
            return this.lineType === 'Medida';
        },
        imgUrl() {
            let url = '';
            if (this.isDisponible) {
                url = this.line.articulo.img_verify;
            } else if (this.isMedida) {
                url = this.line.variety.imagen;
            }
            return url;
        },
        variedadName() {
            let val = '';
            if (this.isDisponible) {
                val = this.line.articulo.nombre_verify;
            } else if (this.isMedida) {
                val = this.line.variety.nombre;
            }
            return val;
        },
        especieName() {
            let val = '';
            if (this.isDisponible) {
                val = (this.line.ecologico ? "ECO " : "") + " " + this.line.articulo.especie_verify.nombre;
            } else if (this.isMedida) {
                val = (this.line.ecologico ? "ECO " : "") + " " + this.line.variety.mote.especie.nombre;
            }
            return val;
        },
        isInjerto() {
            let val = false;
            if (this.isMedida) {
                val = !!this.line.variety_pie;
            }
            return val;
        },
        isEco() {
            let val = false;
            if (this.isDisponible) {
                val = !!this.line.ecologico;
            } else if (this.isMedida) {
                val = !!this.line.ecologico;
            }
            return val;
        },
        isBpSeleccion() {
            let val = false;
            if (this.isMedida) {
                val = !!this.line.ecologico;
            }
            return val;
        },
        variedadPieName() {
            let val = '';
            if (this.isMedida && this.isInjerto) {
                val = this.line.variety_pie.nombre;
            }
            return val;
        },
        especiePieName() {
            let val = '';
            if (this.isMedida && this.isInjerto) {
                val = this.line.variety_pie.mote.especie.nombre;
            }
            return val;
        },
        nBandejas() {
            let val = 0;
            if (this.isDisponible) {
                val = this.line.unidades;
            } else if (this.isMedida) {
                val = this.line.unidades;
            }
            return val;
        },
        importe() {
            let val = 0;
            if (this.isDisponible) {
                val = this.line.importe;
            } else if (this.isMedida) {
                val = this.line.importe;
            }
            return val;
        },
        total() {
            let val = 0;
            if (this.isDisponible) {
                val = this.line.total;
            } else if (this.isMedida) {
                val = this.line.total;
            }
            return val;
        },
        formatoBandejaCompleto() {
            let val = '';
            if (this.isDisponible) {
                val = this.line.bandeja.nombre + 'x' + this.line.semilla_alveolo;
            } else if (this.isMedida) {
                val = this.line.bandeja.nombre + 'x' + this.line.semilla_alveolo;
            }
            return val;
        },
        descuento() {
            let val = 0;
            if (this.isDisponible) {
                val = this.line.ahorro;
            } else if (this.isMedida) {
                val = this.line.ahorro;
            }
            return val;
        },
        canValorar() {
            return this.line.can_valorar_variedad;
        }
    },
    methods: {
        votedEvent() {
            if (this.canValorar) {
                this.line.can_valorar_variedad = 0;
            }
        },
        volverComprar() {
            if (this.isDisponible) {
                this.volverComprarPedidoLine = true;
            } else if (this.isMedida) {
                this.volverComprarMedida();
            }
        },
        volverComprarMedida() {
            if (!this.isMedida) {
                return;
            }
            let formData = new FormData();
            formData.append('pedido_linea_medida', this.line.id);
            this.volverComprarMedidaLoading = true;
            axios.post(this.route('account.pedidos.comprar-linea-medida'), formData).then(response => {
                Vue.toasted.show('Se ha añadido al presupuesto', {
                    type: "success",
                    duration: 3000
                });
            }).catch(err => {
                Vue.toasted.show('Ha habido un error!', {
                    type: "error",
                    duration: 3000
                });
            }).finally(() => {
                this.volverComprarMedidaLoading = false;
            });
        }
    }
}
</script>

<style scoped>
.linea-pedido {
    border-top: solid 1px #646464;
}

.linea-pedido-wrapper {
    padding: 0.75rem;
    display: flex;
    margin-left: -0.5rem;
    margin-right: -0.5rem;
    flex-wrap: wrap;
}

.linea-pedido-img-wrapper {
    flex: 0 0 100px;
    min-width: 100px;
    max-width: 100px;
    padding: 0.5rem;
}

.linea-pedido-img-wrapper img {
    width: 100%;
}

.linea-pedido-variety-info {
    flex: 1 0 calc(66% - 370px);
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.linea-pedido-pricing {
    max-width: 300px;
    flex: 1 0 270px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
}

.linea-pedido-actions {
    flex: 1 1 33%;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
}

.linea-pedido-formato {
    display: flex;
}

.linea-pedido-importe {
    display: flex;
}

.pedido-id-icon {
    margin-left: 5px;
    height: 2rem;
    margin-bottom: 0.75rem;
}

.linea-pedido-btn-wrapper {
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
}

.linea-pedido-id-icon-positioner {
    position: absolute;
    right: 5%;
    top: 0;
    width: 1.4em;
    height: 100%;
    display: flex;
    align-items: center;
}

.linea-pedido-btn {
    color: #6c757d;
    cursor: pointer;
    text-decoration: none;
    border-radius: 0 !important;
    display: block;
    width: 100%;
    transition: none;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    border: 3px solid #6c757d;
    padding: 0.375rem 2rem;
    font-size: 0.9rem;
    line-height: 1.6;
    text-transform: none;
    position: relative;
}

.linea-pedido-btn:hover {
    color: #fff;
    background-color: #6c757d;
}

.comprar-linea-pedido-btn {
    color: #0071bc;
    border-color: #0071bc;
    background-color: #ffba2a;
}

.comprar-linea-pedido-btn:hover {
    background-color: #f29020;
    color: #0071bc;
}

@media screen and (max-width: 991px) {
    .linea-pedido-variety-info {
        flex-basis: 100%;
    }

    .linea-pedido-pricing {
        margin-top: 1rem;
        flex-basis: 100%;
    }

    .linea-pedido-actions {
        margin-top: 1rem;
        flex-basis: 100%;
    }
}


</style>
